"use strict";

import { factTableConstants } from "../_constants";

export const factTableListRequest = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_LIST_REQUEST,
          payload,
     };
};

export const factTableListComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_LIST_COMPLETE,
          payload,
     };
};

export const factTableAddRequest = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_ADD_REQUEST,
          payload,
     };
};

export const factTableAddComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_ADD_COMPLETE,
          payload,
     };
};

export const factTableUpdateRequest = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_UPDATE_REQUEST,
          payload,
     };
};

export const factTableUpdateComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_UPDATE_COMPLETE,
          payload,
     };
};

export const factTableDeleteRequest = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_DELETE_REQUEST,
          payload,
     };
};

export const factTableDeleteComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_DELETE_COMPLETE,
          payload,
     };
};

export const factTableGetRequest = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_GET_REQUEST,
          payload,
     };
};

export const factTableGetComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_GET_COMPLETE,
          payload,
     };
};

export const factTableTypesRequest = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_TYPES_REQUEST,
          payload,
     };
};

export const factTableTypesComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_TYPES_COMPLETE,
          payload,
     };
};

export const factTableLabelsRequest = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_LABELS_REQUEST,
          payload,
     };
};

export const factTableLabelsComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_LABELS_COMPLETE,
          payload,
     };
};

export const factTableActiveInactiveRequest = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_ACTIVE_INACTIVE_REQUEST,
          payload,
     };
};

export const factTableActiveInactiveComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_ACTIVE_INACTIVE_COMPLETE,
          payload,
     };
};

export const factTableValueListRequest = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_SCHEMA_VALUE_LIST_REQUEST,
          payload,
     };
};

export const factTableValueListComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_SCHEMA_VALUE_LIST_COMPLETE,
          payload,
     };
};

export const factTableValueAddRequest = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_VALUE_ADD_REQUEST,
          payload,
     };
};

export const factTableValueAddComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_VALUE_ADD_COMPLETE,
          payload,
     };
};

export const factTableValueUpdateRequest = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_VALUE_UPDATE_REQUEST,
          payload,
     };
};

export const factTableValueUpdateComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_VALUE_UPDATE_COMPLETE,
          payload,
     };
};

export const factTableValueDeleteRequest = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_SCHEMA_VALUE_DELETE_REQUEST,
          payload,
     };
};

export const factTableValueDeleteComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_SCHEMA_VALUE_DELETE_COMPLETE,
          payload,
     };
};

export const factTableSchemaValueGetRequest = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_SCHEMA_VALUE_GET_REQUEST,
          payload,
     };
};

export const factTableSchemaValueGetComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_SCHEMA_VALUE_GET_COMPLETE,
          payload,
     };
};

export const factTableGetAllSchemaTypeRequest = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_GET_ALL_SCHEMA_TYPE_REQUEST,
          payload,
     };
};

export const factTableGetAllSchemaTypeComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_GET_ALL_SCHEMA_TYPE_COMPLETE,
          payload,
     };
};

export const factTableGetAllSchemeAttributeRequest = () => {
     return {
          type: factTableConstants.FACT_TABLE_GET_ALL_SCHEMA_ATTRIBUTE_REQUEST,
     };
};

export const factTableGetAllSchemeAttributeComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_GET_ALL_SCHEMA_ATTRIBUTE_COMPLETE,
          payload,
     };
};

export const factTableSchemaValueReOrderRequest = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_SCHEMA_VALUE_REORDER_REQUEST,
          payload,
     };
};

export const factTableSchemaValueReOrderComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_SCHEMA_VALUE_REORDER_COMPLETE,
          payload,
     };
};

export const factTableGetValueRequest = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_GET_VALUE_REQUEST,
          payload,
     };
};

export const factTableGetValueComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_GET_VALUE_COMPLETE,
          payload,
     };
};

export const factTableSchemaTemplateRequest = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_SCHEMA_TEMPLATE_REQUEST,
          payload,
     };
};

export const factTableSchemaTemplateComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_SCHEMA_TEMPLATE_COMPLETE,
          payload,
     };
};

export const factTableCreateByCsvUploadRequest = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_CREATE_BY_CSV_REQUEST,
          payload,
     };
};

export const factTableCreateByCsvUploadComplete = (payload) => {
     return {
          type: factTableConstants.FACT_TABLE_CREATE_BY_CSV_COMPLETE,
          payload,
     };
};

export const factTableGetJsonSchemaRequest = (payload) => {
     return {
          type: factTableConstants.GET_FACT_TABLE_JSON_SCHEMA_REQUEST,
          payload,
     };
};

export const factTableGetJsonSchemaComplete = (payload) => {
     return {
          type: factTableConstants.GET_FACT_TABLE_JSON_SCHEMA_COMPLETE,
          payload,
     };
};

export const factTableAddTableRecordRequest = (payload) => {
     return {
          type: factTableConstants.ADD_FACT_TABLE_SCHEMA_RECORD_REQUEST,
          payload,
     };
};

export const factTableAddTableRecordComplete = (payload) => {
     return {
          type: factTableConstants.ADD_FACT_TABLE_SCHEMA_RECORD_COMPLETE,
          payload,
     };
};

export const factTableDeleteTableRecordRequest = (payload) => {
     return {
          type: factTableConstants.DELETE_FACT_TABLE_SCHEMA_RECORD_REQUEST,
          payload,
     };
};

export const factTableDeleteTableRecordComplete = (payload) => {
     return {
          type: factTableConstants.DELETE_FACT_TABLE_SCHEMA_RECORD_COMPLETE,
          payload,
     };
};

export const factTableEditTableRecordRequest = (payload) => {
     return {
          type: factTableConstants.EDIT_FACT_TABLE_SCHEMA_RECORD_REQUEST,
          payload,
     };
};

export const factTableEditTableRecordComplete = (payload) => {
     return {
          type: factTableConstants.EDIT_FACT_TABLE_SCHEMA_RECORD_COMPLETE,
          payload,
     };
};

export const factTableGetTableRecordRequest = (payload) => {
     return {
          type: factTableConstants.GET_FACT_TABLE_SCHEMA_RECORD_REQUEST,
          payload,
     };
};

export const factTableGetTableRecordComplete = (payload) => {
     return {
          type: factTableConstants.GET_FACT_TABLE_SCHEMA_RECORD_COMPLETE,
          payload,
     };
};
